import {Injectable} from '@angular/core';
import { UserTypeEnum } from '../shared/interfaces/data.interfaces';
import {MenuItem} from '../shared/interfaces/data.interfaces';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  constructor() { }

  get mainMenu(): MenuItem[] {
    return [


        {
        name: 'Dashboard',
        description: 'View overall statistics and insights',
        logo: '/assets/images/statisctics.png',
        route: '/main-dashboard',
        userType: UserTypeEnum.Staff,
        icon: 'dashboard',
        iconType: 'MATERIAL',
        permissions: ['view_dashboard']
      },



      {
        name: 'Inventory',
        description: 'Manage stock and supplies',
        logo: '/assets/images/boxes.png',
        route: '/invetory',
        userType: UserTypeEnum.Staff,
        icon: 'store',
        iconType: 'MATERIAL',
        permissions: ['view_product']
      },

      {
        name: 'Orders',
        description: 'View and manage customer orders',
        logo: '/assets/images/purchase-order.png',
        route: '/orders',
        userType: UserTypeEnum.Staff,
        icon: 'store',
        iconType: 'MATERIAL',
        permissions: ['view_order']
      },

       {
        name: 'Expenses',
        description: 'Manage and track expenses',
        logo: '/assets/images/poor.png',
        route: '/expenses',
        userType: UserTypeEnum.Staff,
        icon: 'bar_chart',
        iconType: 'MATERIAL',
        permissions: ['view_expense']
      },

       {
        name: 'Reports',
        description: 'View and generate reports',
        logo: '/assets/images/report.png',
        route: '/report',
        userType: UserTypeEnum.Staff,
        icon: 'bar_chart',
        iconType: 'MATERIAL',
        permissions: ['view_report']
      },



        {
        name: 'User Management',
        description: 'Manage application users and roles',
        logo: '/assets/images/management.png',
        route: '/users',
        userType: UserTypeEnum.Staff,
        icon: 'manage_accounts',
        iconType: 'MATERIAL',
        permissions: ['manage_user']
      },

      {
        name: 'Billing & Subscription',
        description: 'Manage your subscription plan and payments',
        route: '/billing',
        userType: UserTypeEnum.Staff,
        icon: 'credit_card',
        iconType: 'MATERIAL',
        permissions: ['manage_shop']
      },
      






      ];
  }

}

